import React from "react";
import MenuItemWithDropdown from "./MenuItemWithDropdown";
import DirectLinkMenuItem from "./DirectLinkMenuItem";
import type { AppTheme } from "themes/global";
import type { NavLinkProps } from "../navigation-links";

interface NavigationItemProps {
  item: NavLinkProps;
  theme: AppTheme;
}

const NavigationItem = ({ item, theme }: NavigationItemProps) => {
  return item.hasMenu ? (
    <MenuItemWithDropdown item={item} theme={theme} />
  ) : (
    <DirectLinkMenuItem item={item} theme={theme} />
  );
};

export default NavigationItem;
